import type { DevicesDevice } from '@smarthome/api';

import { getDeviceIdForApi } from '../utils';

import { DeviceRow } from './DeviceRow';

export interface DeviceListProps {
  devices: DevicesDevice[];
  onTogglePower: (device: DevicesDevice, nextOn: boolean) => void;
  onStopWindowCovering: (device: DevicesDevice) => void;
  onPositionChange: (device: DevicesDevice, positionId: string) => void;
  onOpenControl: (device: DevicesDevice) => void;
  onDelete: (device: DevicesDevice) => void;
  pendingPowerDeviceIds?: Set<string>;
}

export function DeviceList({
  devices,
  onTogglePower,
  onStopWindowCovering,
  onPositionChange,
  onOpenControl,
  onDelete,
  pendingPowerDeviceIds,
}: DeviceListProps) {
  return (
    <div>
      {devices.map((device) => {
        const pendingKey = getDeviceIdForApi(device);
        return (
          <DeviceRow
            key={device.id ?? device.humanId}
            device={device}
            onTogglePower={onTogglePower}
            onStopWindowCovering={onStopWindowCovering}
            onPositionChange={onPositionChange}
            onOpenControl={onOpenControl}
            onDelete={onDelete}
            isPowerPending={pendingPowerDeviceIds?.has(pendingKey)}
          />
        );
      })}
    </div>
  );
}
